import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id identificador del componente
//name: nombre identificador del componente
//items: opciones a elegir [{label: 'TI', title: 'TI'}]
//acceso: Función que retorna los cambios del componente
//optiondisabled: opción que va estar deshabilitada 
//label: valor a mostrar una vez seleccionado
//placeholder: Etiqueta previa antes de seleccionar un registro

AutoComplete.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.array,
  acceso: PropTypes.func,
  optiondisabled: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
};

AutoComplete.defaultProps = {
  id: 'Custom',
  name: 'Custom',
  items: [{ label: 'TI', title: 'TI' }, { label: 'HP', title: 'HP' }],
  acceso: () => { },
  optiondisabled: '',
  label: "",
  placeholder: "",
  helperText: "",
  style: {},
  variant: "standard",
  error: false
}

function AutoComplete(props) {
  return (
    <>
      <Autocomplete
        id={props.id}
        name={props.name}
        options={props.items}
        multiple={props.multiple}
        autoComplete={true}
        onChange={props.acceso}
        disableClearable={true}
        getOptionLabel={(option) => option.label}
        getOptionDisabled={(option) => option.id === props.optiondisabled}
        getOptionSelected={(option, value) => option === value}
        renderOption={(props, option) => (
          <li name={option.label} value={option.id} {...props}>
            {option.label}
          </li>
        )}
        renderInput={(params) => (
          <TextField {...params} error={props.error} variant={props.variant} sx={{ "& .MuiButtonBase-root": { color: '#ffff' } }} value={props.value} style={props.style} label={props.Initial} placeholder={props.placeholder} helperText={props.helperText} endAdornment={false} />
        )}
      />
    </>
  );
}

export default React.memo(AutoComplete);
